import { IUser } from '@common/types';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type TUserStore = {
  user: IUser | null;
  setUser: (user: IUser) => void;
  registerToken: string;
  setRegisterToken: (token: string) => void;
};

/**
 * Used to track global user state
 */
const useUserStore = create<TUserStore>()(
  persist(
    set => ({
      user: null,
      setUser: user => set(() => ({ user })),
      registerToken: '',
      setRegisterToken: token => set(() => ({ registerToken: token })),
    }),
    {
      storage: createJSONStorage(() => localStorage),
      name: 'user',
    },
  ),
);

export default useUserStore;
